import { PageId } from 'constants/pages'

export const enum PageIdStylio1 {
  START_SCREEN_STYLIO_1 = PageId.START_SCREEN_STYLIO_1,
  AGE_STYLIO_1 = PageId.AGE_STYLIO_1,
  URGE_STYLIO_1 = PageId.URGE_STYLIO_1,
  HAIR_COLOR_STYLIO_1 = PageId.HAIR_COLOR_STYLIO_1,
  EYES_COLOR_STYLIO_1 = PageId.EYES_COLOR_STYLIO_1,
  JEWELRY_STYLIO_1 = PageId.JEWELRY_STYLIO_1,
  BODY_SHAPE_STYLIO_1 = PageId.BODY_SHAPE_STYLIO_1,
  STYLIO_TO_HELP_STYLIO_1 = PageId.STYLIO_TO_HELP_STYLIO_1,
  TALL_STYLIO_1 = PageId.TALL_STYLIO_1,
  WEIGHT_STYLIO_1 = PageId.WEIGHT_STYLIO_1,
  URGE_2_STYLIO_1 = PageId.URGE_2_STYLIO_1,
  SHOPPING_STYLIO_1 = PageId.SHOPPING_STYLIO_1,
  STYLE_MOST_MATTERS_STYLIO_1 = PageId.STYLE_MOST_MATTERS_STYLIO_1,
  FAVORITE_COLORS_STYLIO_1 = PageId.FAVORITE_COLORS_STYLIO_1,
  LIKE_OR_DISLIKE_STYLIO_1 = PageId.LIKE_OR_DISLIKE_STYLIO_1,
  LIKE_OR_DISLIKE_11_STYLIO_1 = PageId.LIKE_OR_DISLIKE_11_STYLIO_1,
  LIKE_OR_DISLIKE_12_STYLIO_1 = PageId.LIKE_OR_DISLIKE_12_STYLIO_1,
  LIKE_OR_DISLIKE_13_STYLIO_1 = PageId.LIKE_OR_DISLIKE_13_STYLIO_1,
  LIKE_OR_DISLIKE_14_STYLIO_1 = PageId.LIKE_OR_DISLIKE_14_STYLIO_1,
  LIKE_OR_DISLIKE_15_STYLIO_1 = PageId.LIKE_OR_DISLIKE_15_STYLIO_1,
  LIKE_OR_DISLIKE_16_STYLIO_1 = PageId.LIKE_OR_DISLIKE_16_STYLIO_1,
  LIKE_OR_DISLIKE_17_STYLIO_1 = PageId.LIKE_OR_DISLIKE_17_STYLIO_1,
  LIKE_OR_DISLIKE_18_STYLIO_1 = PageId.LIKE_OR_DISLIKE_18_STYLIO_1,
  LIKE_OR_DISLIKE_19_STYLIO_1 = PageId.LIKE_OR_DISLIKE_19_STYLIO_1,
  STYLES_FEEL_LIKE_YOU_STYLIO_1 = PageId.STYLES_FEEL_LIKE_YOU_STYLIO_1,
  URGE_4_STYLIO_1 = PageId.URGE_4_STYLIO_1,
  BRAND_STYLIO_1 = PageId.BRAND_STYLIO_1,
  FIND_NEW_CLOTHES_STYLIO_1 = PageId.FIND_NEW_CLOTHES_STYLIO_1,
  NOTHING_TO_WEAR_STYLIO_1 = PageId.NOTHING_TO_WEAR_STYLIO_1,
  OLD_CLOTHES_STYLIO_1 = PageId.OLD_CLOTHES_STYLIO_1,
  COMBINE_CLOTHES_STYLIO_1 = PageId.COMBINE_CLOTHES_STYLIO_1,
  OUTFIT_LOOK_STYLIO_1 = PageId.OUTFIT_LOOK_STYLIO_1,
  OPTIMIZE_BUDGET_STYLIO_1 = PageId.OPTIMIZE_BUDGET_STYLIO_1,
  EVERYDAY_LIFESTYLE_STYLIO_1 = PageId.EVERYDAY_LIFESTYLE_STYLIO_1,
  CLIMAT_STYLIO_1 = PageId.CLIMAT_STYLIO_1,
  URGE_3_STYLIO_1 = PageId.URGE_3_STYLIO_1,
  PREPARE_FLOW_STYLIO_1 = PageId.PREPARE_FLOW_STYLIO_1,
  EMAIL_STYLIO_1 = PageId.EMAIL_STYLIO_1,
  EMAIL_CONSENT_STYLIO_1 = PageId.EMAIL_CONSENT_STYLIO_1,
  NAME_STYLIO_1 = PageId.NAME_STYLIO_1,
  SUBSCRIPTIONS_STYLIO_1 = PageId.SUBSCRIPTIONS_STYLIO_1,
  LAST_CHANCE_OFFER_STYLIO_1 = PageId.LAST_CHANCE_OFFER_STYLIO_1,
  CANCEL_OFFER_STYLIO_1 = PageId.CANCEL_OFFER_STYLIO_1,
  SUB_UPSELL_STYLIO_1 = PageId.SUB_UPSELL_STYLIO_1,
  UPSELL_STYLIO_1 = PageId.UPSELL_STYLIO_1,
  DOWNLOAD_STYLIO_1 = PageId.DOWNLOAD_STYLIO_1,
}
